export class ProductColors {
    static get DMSGradient(): Pick<HTMLElement, "className"> {
        return { className: "bg-linear-to-tr from-cyan-400 to-violet-200 shadow-lg" };
    }
    static get FIBUGradient(): Pick<HTMLElement, "className"> {
        return { className: "bg-linear-to-tr from-indigo-400  to-fuchsia-200 shadow-lg" };
    }
    static get ContactsGradient(): Pick<HTMLElement, "className"> {
        return { className: "bg-linear-to-tr from-sky-400 to-yellow-200 shadow-lg" };
    }
    static get ContactsGradientLight(): Pick<HTMLElement, "className"> {
        return { className: "bg-linear-to-tr from-sky-300 to-yellow-100 shadow-lg" };
    }
    static get AIGradient(): Pick<HTMLElement, "className"> {
        return { className: "bg-linear-to-tr from-pink-500 to-indigo-400 shadow-lg text-white" };
    }
    static get DatevGradient(): Pick<HTMLElement, "className"> {
        return { className: "bg-linear-to-tr from-lime-400 to-green-300" };
    }
}
